__turbopack_context__.v({
  "avatarFallback": "JobCardSnow-module__BHum4q__avatarFallback",
  "avatarImage": "JobCardSnow-module__BHum4q__avatarImage",
  "avatarPanel": "JobCardSnow-module__BHum4q__avatarPanel",
  "avatarWrapper": "JobCardSnow-module__BHum4q__avatarWrapper",
  "bottom": "JobCardSnow-module__BHum4q__bottom",
  "card": "JobCardSnow-module__BHum4q__card",
  "cta": "JobCardSnow-module__BHum4q__cta",
  "ctaIcon": "JobCardSnow-module__BHum4q__ctaIcon",
  "headings": "JobCardSnow-module__BHum4q__headings",
  "highlights": "JobCardSnow-module__BHum4q__highlights",
  "name": "JobCardSnow-module__BHum4q__name",
  "recruiterLogo": "JobCardSnow-module__BHum4q__recruiterLogo",
  "recruiterLogoPlaceholder": "JobCardSnow-module__BHum4q__recruiterLogoPlaceholder",
  "root": "JobCardSnow-module__BHum4q__root",
  "skill": "JobCardSnow-module__BHum4q__skill",
  "skillEmoji": "JobCardSnow-module__BHum4q__skillEmoji",
  "skillsLabel": "JobCardSnow-module__BHum4q__skillsLabel",
  "skillsList": "JobCardSnow-module__BHum4q__skillsList",
  "skillsPanel": "JobCardSnow-module__BHum4q__skillsPanel",
  "title": "JobCardSnow-module__BHum4q__title",
  "top": "JobCardSnow-module__BHum4q__top",
});
